'use strict';

var TDChartPOSFilterFactory = function TDChartPOSFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ServiceDemandDateRangeFilterFactory', 'ServiceDemandTimeOfDayFilterFactory', 'ServiceDemandNumberOfStopsFilterFactory', 'ServiceDemandDowFilterFactory', 'ServiceDemandClassFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function TDChartPOSFilter() {
    DemandFilter.call(this, 'service', 'thematic-demand-chart-service-pos');
    this.registerFilters(injectedFilters);
  }
  TDChartPOSFilter.constructor = TDChartPOSFilter;
  TDChartPOSFilter.prototype = Object.create(DemandFilter.prototype);
  return TDChartPOSFilter;
};
TDChartPOSFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = TDChartPOSFilterFactory;